import { render, staticRenderFns } from "./OwnSnack.vue?vue&type=template&id=4b203150&scoped=true&"
import script from "./OwnSnack.vue?vue&type=script&lang=js&"
export * from "./OwnSnack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b203150",
  null
  
)

export default component.exports